export var PapiFieldType;
(function (PapiFieldType) {
    PapiFieldType["String"] = "STRING";
    PapiFieldType["Float"] = "FLOAT";
    PapiFieldType["Datetime"] = "DATETIME";
    PapiFieldType["Int"] = "INT";
})(PapiFieldType || (PapiFieldType = {}));
//# sourceMappingURL=papi-integrations.js.map